import React from 'react';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import type { Option } from '../types/form';

type Props = {
  label?: React.ReactNode;
  value: string[] | unknown;
  options: Option[];
  handleChange: (value: string[]) => void;
  handleBlur?: (value: string[]) => void;
};

function CheckboxSelectField(props: Props) {
  const { label, options, handleChange, handleBlur } = props;
  const [value, setValue] = React.useState<string[]>(Array.isArray(props.value) ? props.value : []);

  const isSelected = (selectedValue: string): boolean => {
    return value.includes(selectedValue);
  };

  return (
    <FormGroup row>
      {label != null && (
        <Typography fontWeight='bold' width='100%'>
          {label}
        </Typography>
      )}
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          control={
            <Checkbox
              checked={isSelected(option.value)}
              onChange={() => {
                const newValue = isSelected(option.value)
                  ? value.filter((key) => key !== option.value)
                  : value.concat([option.value]);

                setValue(newValue);
                handleChange(newValue);
              }}
              inputProps={{
                onBlur: () => {
                  if (handleBlur !== null && handleBlur !== undefined) {
                    handleBlur(value);
                  }
                },
              }}
            />
          }
          label={option.label}
        />
      ))}
    </FormGroup>
  );
}

export default CheckboxSelectField;
